import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const FakeInput = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'question-text w-full rounded-md border border-border px-2.5 py-1 text-sm text-gray-700'
    )}
    {...props}
  />
)
